import { Box, VStack } from '@cdl/heartbeat-react';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { EmptyContent } from '../../../shared/components/EmptyContent';
import {
  emptyMessageClusterSelector,
  selectedBaseClustersSelector,
  showEmptyClusterStateSelector,
  showLoaderSelector,
} from '../selectors/cluster.selectors';
import { BaseClustersContainer } from './baseClusters/BaseClustersContainer';
import { BeatColumn } from './beatColumn/BeatColumn';
import { ClassificationDropdown } from './beatColumn/ClassificationDropdown';
import { ClusterPlot } from './clusterPlot/ClusterPlot';
import { LoadingCleaning } from './loadingComponents/LoadingCleaning';
import { LorenzPlot } from './lorenzPlot/LorenzPlot';
import { NavigateMergeButton } from './Navigation/NavigateMergeButton';

export const Cleaning: React.FC = () => {
  const showLoader = useSelector(showLoaderSelector);
  const selectedClusters = useSelector(selectedBaseClustersSelector);
  const message = useSelector(emptyMessageClusterSelector);
  const [beatContainer, setBeatContainer] = useState<HTMLElement | null>();
  const [height, setHeight] = useState<number | string>('100%');
  const showEmptyState = useSelector(showEmptyClusterStateSelector);

  useEffect(() => {
    const onResize = () => {
      if (beatContainer == null) {
        return '100%';
      }
      setHeight(window.innerHeight - beatContainer.offsetTop);
    };
    onResize();
    window.addEventListener('resize', debounce(onResize, 150));
    return () => window.removeEventListener('resize', onResize);
  }, [beatContainer]);

  if (showLoader) {
    return <LoadingCleaning />;
  }

  return (
    <>
      <NavigateMergeButton />
      <BaseClustersContainer>
        <ClassificationDropdown
          clusters={selectedClusters}
          title='Reclassify'
        />
      </BaseClustersContainer>
      <Box display='flex' justifyContent='center' ref={setBeatContainer}>
        <VStack spacing='m' mr='l' mt='l'>
          <ClusterPlot />
          <LorenzPlot />
        </VStack>
        <BeatColumn />
        {showEmptyState && (
          <EmptyContent message={message} width='100%' height={height} />
        )}
        {selectedClusters.length > 1 && (
          <Box
            position='absolute'
            height={height}
            width='100%'
            bgColor='black'
            opacity='0.5'
          />
        )}
      </Box>
    </>
  );
};
